import { useSavableProperty } from "#src/composables/savable-property.composable.js";

import {
  validateInList,
  validateIsBeforeNow,
} from "#src/composables/savable-property-validators.mjs";
import {
  SMOKING_FREQUENCIES,
  SMOKING_TYPES,
} from "#src/structures/SmokingUsage.js";
import { generateUuid } from "#src/util/helpers.js";
import { defineStore } from "#src/stores/state-wrapper.js";

export const smokingUsageNameGenerator = () =>
  `smoking-usage-${generateUuid()}`;
export const useSmokingUsage = (id, pinia, hot) =>
  defineStore(id, {
    state: () => ({
      id: null,
      last_use_date: useSavableProperty({
        requestMap: "last_use_date",
        group: "smoker",
        rules: {
          dateIsBeforeNow: validateIsBeforeNow(),
        },
      }),
      category: useSavableProperty({
        requestMap: "category",
        group: "smoker",
        rules: {
          inList: validateInList(SMOKING_TYPES),
        },
      }),
      frequency: useSavableProperty({
        requestMap: "frequency",
        group: "smoker",
        rules: {
          inList: validateInList(SMOKING_FREQUENCIES.map(f => f.value)),
        },
      }),
    }),
  })(pinia, hot);
